export default function Hero() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[680px] flex items-center overflow-hidden bg-background-950"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20theater%20background%20with%20warm%20red%20and%20amber%20ambient%20lighting%2C%20abstract%20film%20reel%20textures%2C%20soft%20bokeh%20lights%2C%20luxurious%20movie%20premiere%20atmosphere%2C%20deep%20shadows%20with%20golden%20highlights%2C%20elegant%20streaming%20platform%20visual%2C%20no%20text%20no%20people%20clean%20composition&width=1600&height=900&seq=hero-tianmei-bg&orientation=landscape"
          alt="天美影视高清在线观影背景"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/90 via-background-950/70 to-background-950/40"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 w-full max-w-[1280px] mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/15 border border-accent-500/25 mb-5">
              <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
              <span className="text-xs md:text-sm font-medium text-accent-400 whitespace-nowrap">每日更新 · 海量片库</span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-background-50 leading-tight">
              天美影视 · 高清免费在线观影平台
            </h1>

            <p className="mt-3 text-base md:text-lg text-accent-300 font-medium">
              不缓冲不卡顿，随时随地畅享流畅追剧体验
            </p>

            <p className="mt-6 text-sm md:text-base text-foreground-300 leading-relaxed max-w-[600px] mx-auto lg:mx-0">
              天美影视汇聚海量高清电影、热播电视剧、热门综艺与动漫番剧，每日同步更新最新片源。采用智能加速引擎，确保不缓冲不卡顿，为您带来极致流畅的在线观影体验。无论是最新上映的大片，还是经典重温的好剧，天美影视都能满足您的追剧需求。
            </p>

            <div className="mt-7 flex flex-wrap items-center gap-5 md:gap-8 justify-center lg:justify-start">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-lg bg-primary-500/20 flex items-center justify-center">
                  <i className="ri-film-line text-primary-400 text-sm"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-background-50">20,000+</div>
                  <div className="text-xs text-foreground-400">影视资源</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-lg bg-accent-500/20 flex items-center justify-center">
                  <i className="ri-flashlight-line text-accent-400 text-sm"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-background-50">极速加载</div>
                  <div className="text-xs text-foreground-400">不缓冲不卡顿</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-lg bg-secondary-500/20 flex items-center justify-center">
                  <i className="ri-shield-check-line text-secondary-400 text-sm"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-background-50">安全流畅</div>
                  <div className="text-xs text-foreground-400">高清画质保障</div>
                </div>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#carousel"
                onClick={(e) => handleScrollTo(e, '#carousel')}
                className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-play-circle-fill text-lg"></i>
                立即观影
              </a>
              <a
                href="#features"
                onClick={(e) => handleScrollTo(e, '#features')}
                className="inline-flex items-center gap-2 px-7 py-3.5 bg-background-50/10 hover:bg-background-50/20 text-background-50 font-medium rounded-lg border border-background-50/20 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-information-line text-lg"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[520px]">
            <div className="relative">
              <div className="absolute -inset-1 bg-gradient-to-r from-primary-500/30 via-accent-500/20 to-primary-500/30 rounded-2xl blur-xl"></div>
              <div className="relative rounded-2xl overflow-hidden border border-background-50/10">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20with%20warm%20golden%20and%20deep%20red%20tones%2C%20abstract%20film%20frames%20floating%20in%20dramatic%20lighting%2C%20luxurious%20cinema%20atmosphere%20with%20lens%20flares%2C%20elegant%20entertainment%20visual%20without%20text%2C%20professional%20movie%20poster%20quality%2C%20rich%20contrast%20and%20depth&width=1040&height=1300&seq=hero-poster-main&orientation=portrait"
                  alt="天美影视精选推荐主视觉"
                  className="w-full h-auto object-cover"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background-950/80 to-transparent p-5">
                  <div className="flex items-center gap-3">
                    <span className="px-3 py-1 bg-primary-500 text-background-50 text-xs font-semibold rounded-full whitespace-nowrap">热播中</span>
                    <span className="text-background-50 text-sm font-medium">精选好片每日更新</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}